<!-- <div class="flex-container" [attr.id]="elementId"> -->
<!-- <div [attr.id]="elementId"> -->
<div>
  <!-- <div class="flex-child-20"> -->
  <div>
    <input [attr.id]="id" class="form-control" type="text" [formControl]="searchControl" [style.width]="inputWidth()"
      placeholder="{{placeHolder}}" style="text-transform: lowercase;" [readonly]="readOnly" />
    <!-- <input id="search" class="form-control" type="text" [formControl]="searchControl" [style.width]="inputWidth()"
      placeholder="Type email address to search..." style="text-transform: lowercase;" /> -->

  </div>
  <div>
    <!-- <div class="flex-child-20"> -->
    <!-- <pre>searching: {{searching()}}</pre> -->
    @if(found()) {
    <!-- <span>Found</span> -->
    } @else {
    @if(searching()) {
    <span><fa-icon [icon]="['fat', 'spinner']" animation="spin"></fa-icon></span>
    }
    }
  </div>

</div>

<!-- <form [formGroup]="form" class="k-form-inline">
  <div class="row">

  </div>
  <div class="row">

    <div class="search-container k-form-field">
      <label for="search" class="form-label col-4">{{labelText}}:</label>
      <div class="col-7">

        <input id="search" class="form-control" type="text" formControlName="email" [style.width]="inputWidth()"
          placeholder="Type email address to search..." style="text-transform: lowercase;" />
        @if(email?.invalid && (email?.dirty || email?.touched)){
        <div class="alert alert-danger">
          @if(email?.errors?.['required']) {
          <div>Email is required.</div>
          }
          @if(email?.errors && email?.errors?.['email']) {
          <div>Please, enter valid email address.</div>
          }
        </div>
        }
      </div>
      <div class="col-1">
        @if(found()) {
        <div>
          <span>Found</span>
        </div>
        } @else {
        <div>
          @if(searching()) {
          <div>
            <span><fa-icon [icon]="['fat', 'spinner']" animation="spin"></fa-icon> ... </span>
          </div>
          }
        </div>
        }

      </div>
    </div>

  </div>
</form> -->
